<template>
  <page-card>
    <template slot="header">
      <span>Business Verification</span>
    </template>
    <div slot="body">
      <HKbusinessKYC
        v-if="area === 'HK'"
        :area="area"
        ref="HKbusinessKYC"
      ></HKbusinessKYC>
      <OtherBusinessKYC
        v-else
        :area="area"
        ref="OtherBusinessKYC"
      ></OtherBusinessKYC>
    </div>
  </page-card>
</template>

<script>
import OtherBusinessKYC from "@/views/authentication/businessKYC/components/OtherBusinessKYC.vue";
import HKbusinessKYC from "@/views/authentication/businessKYC/components/HKbusinessKYC.vue";
export default {
  components: { OtherBusinessKYC, HKbusinessKYC },
  props: {
    area: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  methods: {
    submit() {
      return new Promise((resolve, reject) => {
        let comp = this.area === "HK" ? "HKbusinessKYC" : "OtherBusinessKYC";
        this.$refs[comp]
          .submit()
          .then(res => {
            console.log(res)
            resolve(res);
          })
          .catch(e => {
            console.log(e)
            reject(e);
          });
      });
    }
  }
};
</script>
<style scoped lang="scss"></style>
